import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PasButtonRoundColor, PasButtonRoundComponent } from '@porsche-aftersales/frontend-toolbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { SupplierConditionStore } from './supplier-condition.store';

enum Icon {
  DisplayOnly = 'search',
  Edit = 'mode_edit',
  Delete = 'delete',
}

@Component({
  templateUrl: './button-cell-renderer.component.html',
  styleUrls: ['./button-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PasButtonRoundComponent],
})
export class ButtonCellRendererComponent implements ICellRendererAngularComp {
  private readonly supplierConditionStore = inject(SupplierConditionStore);

  private params: ICellRendererParams;

  public iconEdit = '';
  public isHidden = false;

  public readonly iconDelete = Icon.Delete;
  public readonly iconColor = PasButtonRoundColor.DARK;

  public agInit(params: ICellRendererParams): void {
    this.isHidden = params.data.supplierNumber === '*';

    // TODO const isSupplierConditionEditable = isDateExpired(this.params.data.validTo); ?
    const determineIconByExpirationDate = (): string => Icon.Edit;

    this.params = params;
    this.iconEdit = determineIconByExpirationDate();
  }

  public refresh(): boolean {
    return true;
  }

  public onEditClick(): void {
    this.supplierConditionStore.editSupplierCondition(this.params.data.id);
  }

  public onDeleteClick(): void {
    this.supplierConditionStore.deleteSupplierCondition(this.params.data.id);
  }
}
